
export class CardPrepaidModel{
    phone: string;
    email: string;
    code: string;
    number_sheet: string;
    constructor(){}
}